import { useMemo } from 'react';
import moment from 'moment';
import { STYLED_DAY_CLASSES } from './Calendar.style';
import useStyleAssigner from 'common/hooks/utils/useStyleAssigner';
import { SEARCH_DATE_FORMAT } from 'common/constants/constants';
import { CALENDAR_COLORS } from '../CalendarView.style';
import useSelectedFilterSet from '../../../../../state/filters/hooks/useSelectedFilterSet';
import { ForecastFiltersContext } from '../../../../../state/filters/contexts';

const dateKeyFormat = date => moment(date).format(SEARCH_DATE_FORMAT);

const useCalendarStyles = ({ forecast }) => {
  const styleAssigner = useStyleAssigner();
  const selectedFilterSet = useSelectedFilterSet(ForecastFiltersContext);
  const dueDate = selectedFilterSet?.metadata?.due_date;

  const initDaysStyles = () => {
    styleAssigner.reset();

    //init today style
    const today = moment();
    const todayKey = dateKeyFormat(today);
    styleAssigner.addClassName(todayKey, STYLED_DAY_CLASSES.CIRCLE);
    styleAssigner.setStyleAttr(todayKey, 'borderColor', CALENDAR_COLORS.TODAY);

    //init dueDate style
    if (dueDate) {
      const dueDayKey = dateKeyFormat(dueDate);
      styleAssigner.addClassName(dueDayKey, 'circle');
      styleAssigner.setStyleAttr(
        dueDayKey,
        'borderColor',
        CALENDAR_COLORS.DUE_DATE
      );
    }

    // init finishedWeeks - weekDays styles
    forecast.finishedWeeks?.forEach(item => {
      const endWeekDay = moment(item.week);
      const weekDays = [];

      for (let i = 0; i <= 6; i++) {
        const weekDay = moment(endWeekDay).subtract(i, 'days');
        weekDays.push(weekDay);
      }

      weekDays.forEach((weekDay, idx) => {
        const isFirst = idx === 0;
        const isLast = idx === weekDays.length - 1;

        const weekDayKey = dateKeyFormat(weekDay);
        styleAssigner.addClassName(weekDayKey, STYLED_DAY_CLASSES.FILL);
        styleAssigner.setStyleAttr(weekDayKey, 'backgroundColor', item.color);
        if (isFirst) styleAssigner.addClassName(weekDayKey, 'isLast');
        if (isLast) styleAssigner.addClassName(weekDayKey, 'isFirst');
      });
    });
  };

  useMemo(initDaysStyles, [forecast.finishedWeeks, dueDate]);

  const getDayStyles = day => styleAssigner.getStyles(dateKeyFormat(day));

  return {
    getDayStyles
  };
};

export default useCalendarStyles;
